import React, { useEffect, useState } from "react";
import CommonLayout from "../../../layouts/CommonLayout";
import { getBlockList, unblock } from "../../../../api/BlockApi";
import { ConfirmModal } from "../../../layouts/ConfirmModal";
import { AlertModal } from "../../../layouts/AlertModal";
import { IoPersonOutline } from "react-icons/io5";

const BlockManagementPage = () => {
    const [blocks, setBlocks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmState, setConfirmState] = useState({ isVisible: false, blockedId: null, blockedName: "" });
    const [alertState, setAlertState] = useState({ isVisible: false, message: "", callback: null });

    const loadBlocks = async () => {
        try {
            setIsLoading(true);
            const response = await getBlockList();
            setBlocks(response?.blockDtoList || []);
        } catch (e) {
            console.error("차단 목록 로딩 실패", e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadBlocks();
    }, []);

    const handleAskUnblock = (blockedId, blockedName) => {
        setConfirmState({ isVisible: true, blockedId, blockedName });
    };

    const handleConfirmUnblock = async () => {
        try {
            if (!confirmState.blockedId) return;
            await unblock(confirmState.blockedId);
            setConfirmState({ isVisible: false, blockedId: null, blockedName: "" });
            await loadBlocks();
            setAlertState({ isVisible: true, message: "차단이 해제되었습니다.", callback: null });
        } catch (e) {
            const message = e?.response?.data?.message || "차단 해제 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
            setAlertState({ isVisible: true, message, callback: null });
        }
    };

    const handleCancelUnblock = () => {
        setConfirmState({ isVisible: false, blockedId: null, blockedName: "" });
    };

    return (
        <CommonLayout title="차단 밥친구 관리">
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: "", callback: null })}
            />
            <div className="p-4">
                {isLoading ? (
                    <div className="text-center text-gray-500 py-12">불러오는 중...</div>
                ) : blocks.length === 0 ? (
                    <div className="text-center text-gray-500 py-12">차단한 밥친구가 없습니다.</div>
                ) : (
                    <ul className="divide-y divide-gray-200 rounded-lg border border-gray-200 overflow-hidden">
                        {blocks.map((b) => (
                            <li key={b.blockedId} className="flex items-center justify-between p-3 bg-white">
                                <div className="flex items-center min-w-0">
                                    <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden mr-3 flex-shrink-0 flex items-center justify-center">
                                        {b.blockedImageUrl ? (
                                            <img src={b.blockedImageUrl} alt={b.blockedName} className="w-full h-full object-cover" />
                                        ) : (
                                            <IoPersonOutline size={24} className="text-gray-400" />
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-medium text-gray-900 truncate">{b.blockedName}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => handleAskUnblock(b.blockedId, b.blockedName)}
                                    className="px-3 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg active:bg-gray-200 whitespace-nowrap"
                                >
                                    해제
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <ConfirmModal
                isVisible={confirmState.isVisible}
                title="차단 해제"
                message={`${confirmState.blockedName} 님을 차단 해제하시겠습니까?`}
                onConfirm={handleConfirmUnblock}
                onCancel={handleCancelUnblock}
            />
        </CommonLayout>
    );
};

export default BlockManagementPage;
